// src/ui/featureFlags.js
// Flags del refactor visual (design system). Aplicacion incremental.
//
// NEW_SHELL: activa el App Shell nuevo (AppSidebar + layout responsive, F1).
// Ponlo en false para volver al layout legacy (Semantic UI) y comparar.
// Solo para validacion en local; la decision de subir la toma el equipo.
export const NEW_SHELL = true;

// NEW_TAREAS: activa el rediseno de la pantalla Tareas (F3): listado limpio
// "Mis tareas" (AntD) + modal de detalle, y la creacion en un Drawer lateral.
// En false se vuelve al grid legacy (lista Semantic UI) para comparar en local.
export const NEW_TAREAS = true;

// NEW_ITINERARIOS: activa el rediseno de la pantalla Itinerarios (F4): cards de
// itinerario + escenas en lista (SceneCard) + panel de clase + visor de escena,
// todo AntD. En false se vuelve al grid legacy (Semantic UI).
export const NEW_ITINERARIOS = true;

// NEW_ASISTENTES: activa el rediseno de la pantalla Asistentes IA (F5): header con
// PageHeader, segmented verde y galeria compacta de tarjetas de personaje
// (AssistantCard) con avatar protagonista, chip de propiedad y boton "Chatear".
// En false se vuelve a la version legacy (paleta azul, tarjeta apaisada).
export const NEW_ASISTENTES = true;

// NEW_EVALUACIONES: activa el rediseno de la pantalla Evaluaciones (F6): pagina
// envuelta en educaBrandTheme (verde), tabla limpia con acciones planas
// (editar/ranking/borrar) y modal de creacion/edicion en verde. En false se
// vuelve a la version legacy (botones azul marino/naranja/rojo solido).
export const NEW_EVALUACIONES = true;

// NEW_LOGIN: activa la intro animada del login (/auth): secuencia de 5 frames de
// aula (de pie -> sentados, camara a la pizarra) reproducida UNA vez al entrar,
// logo entrando por la izquierda, particulas, y el panel de login (verde) sobre
// la pizarra. No toca la logica de LoginForm. En false se ve el login legacy.
export const NEW_LOGIN = true;

// NEW_SALAS: activa el rediseno de la pantalla Salas y Catalogo VR (F8), la mas
// compleja: pagina en educaBrandTheme (header verde), seccion de categorias
// VISUAL (tiles icono+label+color, color y icono desde fuente unica / avatar de
// BD), subcategorias en chips, cards de escena AntD (titulo a 2 lineas + punto de
// color), panel "Mis Itinerarios" migrado de Semantic a AntD + sus modales, y
// wizard crear/editar itinerario AntD verde. En false se vuelve al legacy
// (Semantic UI + pills de colores legacy).
export const NEW_SALAS = true;

// NEW_EDUCAMAKER: activa el rediseno de la pantalla Mis escenas / Educamaker (F7):
// pagina en educaBrandTheme (tabs/botones verdes), tarjetas de escena en AntD
// (imagen + titulo + tag de categoria + Ver/Editar) y wizard de creacion/edicion
// migrado de Semantic UI a AntD (Steps + form verde), conservando Formik, la
// creacion module_00/module_01, el cleanup de escena fantasma y SceneFormFile.
// En false se vuelve a la version legacy (Semantic UI, paleta azul/naranja/rojo).
export const NEW_EDUCAMAKER = true;

// NEW_STUDENT_HOME: activa el rediseno del Portal del Alumno (Capa 2, strangler).
// En false (DEFAULT) se ve el portal actual (StudenthomeGrid / Semantic UI) y no
// cambia NADA en produccion. En true se monta el portal nuevo (seleccion de modo
// VR/pantalla + shell tematizado + home "Hoy"). Ponlo en true SOLO en local para
// validar (como DEVELOPMENT, no se commitea en true hasta cerrar el refactor).
// Doc: design-system/student-portal/STATUS.md
export const NEW_STUDENT_HOME = true;

// NEW_TEACHER_EVAL_DASHBOARD: reorganiza la pantalla Evaluaciones del profesor en
// un DASHBOARD por clases/alumnos (strangler sobre la pagina actual). En false
// (DEFAULT) se ve la pagina actual (ListQuiz tal cual) y no cambia NADA. En true
// se monta el dashboard: selector de clase + KPIs + apartados Examenes / Alumnos,
// tabla de alumnos por clase (E1), detalle de alumno (E2) y ranking por examen.
// Lectura del embebido (coherente con ranking/portal alumno). Ponlo en true SOLO
// en local para validar. Doc: design-system/teacher-evaluations/PLAN.md
export const NEW_TEACHER_EVAL_DASHBOARD = true;

// EDUCAMAKER_STATUS_BANNER: banner de gracia/corte de la licencia EducaMaker
// (P4 del plan maestro EDUCAMAKER_ACCESO_PLAN_MAESTRO.md 4.2). En true, el
// portal consulta GET /educamaker/status y muestra la franja ambar (gracia,
// cuenta atras de 3 dias / past_due) o roja (corte) a owner y profesores de
// instituciones con plan EducaMaker. En false no se consulta ni se muestra.
export const EDUCAMAKER_STATUS_BANNER = true;

// EDUCAMAKER_UPSELL_GATE: puerta de acceso a EducaMaker por plan (P1 del plan
// maestro docs/architecture/EDUCAMAKER_ACCESO_PLAN_MAESTRO.md). En true, los
// usuarios cuyo JWT lleva plan_key fuera de {creator, enterprise} ven el popup
// de upsell (EducamakerUpsellModal) al pulsar el boton "Educamaker" en vez de
// abrirse educa360.es; los planes con EducaMaker entran directo. Tokens SIN
// claim plan_key (legacy/admin) NUNCA se bloquean. En false se vuelve al
// comportamiento anterior (window.open sin barrera).
export const EDUCAMAKER_UPSELL_GATE = true;

// NEW_TEACHER_TRAINING: publica la pagina "Formacion" en el portal del profesor
// (/portal/teacher/formacion) y en el de la institucion (/portal/inst/formacion):
// videos, guias PDF e informacion de uso de la plataforma, con el contenido que
// el admin gestiona en /admin/formacion. En false no aparece en el menu ni la
// ruta esta montada (util para desplegar el backend y el panel admin antes de
// abrirla a los usuarios, mientras se carga el contenido).
export const NEW_TEACHER_TRAINING = true;

// STYLES_RUNTIME: activa la capa de tema runtime del editor de estilos (Capa 1).
// El ThemeRuntimeProvider declara los tokens semanticos (--edu-*) en :root y
// permite aplicar overrides en vivo. Sin overrides, los valores son los actuales
// => la web se ve IDENTICA (los SCSS tokenizados ya tienen fallback al valor de
// hoy). En false el provider es no-op y se comporta exactamente como antes.
// Doc: design-system/styles-editor/ (LAYERS.md, ROADMAP.md F1).
export const STYLES_RUNTIME = true;
